import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Timestamp({data}) {
    return (
        <div className="time_section p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="m-auto">
                        <h5 className="episode_name text-start">
                            Timestamps
                        </h5>
                        <ul className="timestamp">
                            <li><span>1:03</span> Introduction</li>
                            <li><span>1:24</span> About Guest</li>
                            <li><span>2:29</span> Podcast’s Topic</li>
                            <li><span>3:08</span> Aliya’s Story</li>
                            <li><span>5:47</span> What Brings Aliya to Dubai?</li>
                            <li><span>7:03 </span> Who motivated Aliya to become a coach?</li>
                            <li><span>8:15</span> What’s personal development for Aliya?</li>
                            <li><span>11:29</span> Does life coaching always change one’s perspective completely?</li>
                            <li><span>12:50</span> At what point do people realize they need help?</li>
                            <li><span>13:58</span> What is the biggest Myth about life coaching?</li>
                            <li><span>15:31</span> What biggest challenge Aliya faced?</li>
                            <li><span>17:10</span> How did Aliya break the barriers?</li>
                            <li><span>18:13</span> What’s Aliya’s Favorite Audience?</li>
                            <li><span>19:39</span> Advice for up-and-coming life coaches?</li>
                            <li><span>21: 22</span> Aliya’s Productivity hack for entrepreneurs?</li>
                            <li><span>23:24</span> Do most entrepreneurs get mental health issues?</li>
                            <li><span>25:55</span> Is avoiding burnout the end goal of entrepreneurship?</li>
                            <li><span>28:54</span> How does Aliya define success?</li>
                            <li><span>31:36</span> One thing Aliya would like to change about life coaching in UAE?</li>
                            <li><span>35:13</span> How can this change become a reality?</li>
                            <li><span>36:48</span> How can technology help life coaches and speakers?</li>
                        </ul>
                    </Col>
                </Row>

            </Container>
        </div>
    );
}

export default Timestamp;